// Through the api barrel, like every caller this replaced, so tests that stub
// `utils/api` keep controlling the stored-chatbot fallback.
import { readStoredStringArray } from "./api";

/** Trimmed, non-empty chatbot ids without the "ALL" placeholder, in their original order. */
export function normalizeChatbotIds(ids: unknown): string[] {
  if (!Array.isArray(ids)) return [];
  return ids.map((id) => String(id || "").trim()).filter((id) => id && id !== "ALL");
}

/**
 * Chatbot ids a scoped dashboard request covers: the sidebar scope's chatbots,
 * else the selected chatbot, else every chatbot the signed-in user has stored.
 */
export function resolveScopedChatbotIds(
  scopeChatbotIds: unknown,
  selectedChatbotId?: string | null,
) {
  const fromScope = normalizeChatbotIds(scopeChatbotIds);
  if (fromScope.length > 0) {
    return fromScope;
  }
  if (selectedChatbotId && selectedChatbotId !== "ALL") {
    return [selectedChatbotId];
  }
  return normalizeChatbotIds(readStoredStringArray("chatbot_ids"));
}
